// CANONICAL COPY (GH #7115). src/constants/obligations/obl-remote-working-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-remote-working-policy',
  title: 'Verify remote working security measures',
  description:
    'Confirm that remote working security measures are documented, published, and acknowledged by remote workers.',
  category: 'people',
  scfIds: ['SCF-PPL-007'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Remote working policy is published' },
    { type: 'document-acknowledged', description: 'Remote workers have acknowledged the policy' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
